import Http from '../../../http';
import * as types from '../constants';
import { startLoadingList, stopLoadingList } from '../../../common/hoc/withLoaingList';
import { include as shopBarbersInclude } from './shop';

export const fetchBarberSchedules = barberId => (dispatch) => {
  dispatch({ type: types.BARBER_GET_SCHEDULES });

  return Http.get(`/barber/${barberId}/schedules`).then((response) => {
    dispatch({
      type: types.BARBER_SET_SCHEDULES,
      payload: response,
    });
  }).catch((err) => {
    dispatch({ type: types.BARBER_GET_SCHEDULES_ERROR });
    return err;
  });
};

export const fetchBarberDaysOff = barberId => (dispatch) => {
  dispatch({ type: types.BARBER_GET_DAYS_OFF_BY_SHOP });

  return Http.get(`/barber/${barberId}/all-days-off`).then((response) => {
    dispatch({
      type: types.BARBER_SET_DAYS_OFF_BY_SHOP,
      payload: response,
    });
  }).catch((err) => {
    dispatch({ type: types.BARBER_GET_DAYS_OFF_BY_SHOP_ERROR });
    return err;
  });
};

export const fetchBarberDaysOn = barberId => (dispatch) => {
  dispatch({ type: types.BARBER_GET_DAYS_ON_BY_SHOP });

  return Http.get(`/barber/${barberId}/all-days-on`).then((response) => {
    dispatch({
      type: types.BARBER_SET_DAYS_ON_BY_SHOP,
      payload: response,
    });
  }).catch((err) => {
    dispatch({ type: types.BARBER_GET_DAYS_ON_BY_SHOP_ERROR });
    return err;
  });
};

export const checkBarberUsernameAvailability = username => Http.post('/user/check-username', { username });

export function getDeletedBarbers(ownerId, ownerType = 'shop') {
  const apiFilter = ownerType === 'brand'
    ? {
      sortBy: 'order:asc,createdAt:desc',
      withDeleted: true,
    }
    : {
      include: shopBarbersInclude.join(','),
      limit: 500,
      sortBy: 'order:asc,createdAt:desc',
      withDeleted: true,
    };

  return (dispatch) => {
    dispatch(startLoadingList());
    return (
      Http.get(`/${ownerType}/${ownerId}/barber`, apiFilter)
        .then((barbers) => {
          dispatch({
            type: types.GET_DELETED_BARBERS,
            payload: barbers,
            ownerType,
          });
          dispatch(stopLoadingList());

          return barbers;
        })
        .catch((err) => {
          dispatch(stopLoadingList());
          return err;
        })
    );
  };
}

export function saveBarberImage(barberId, image) {
  return dispatch => Http.postRaw(`/barber/${barberId}/profile_photo`, {
    enabled: true,
    order: 0,
    image,
  }).then((photo) => {
    dispatch({ type: types.ADD_BARBER_PHOTO });
    return photo;
  });
}
